import Usuario from "../../models/usuario";
import { ActionsEnum } from "../enum/actions-enum";

const initialState = {
	usuarioLogado: new Usuario(),
};
export const usuarioReducer = (state = initialState, action) => {
	if (action.type === ActionsEnum.UPDATE_USUARIO_LOGADO) {
		return {
			...state,
			usuarioLogado: action.usuarioLogado,
		};
	} else {
		return state;
	}
};
